'use strict';
module.exports = function pageScrollKeyOverride(domElement) {
	const PAGE_UP = 33, PAGE_DOWN = 34,
		handler = function (e) {
			if (e.which === PAGE_DOWN || e.which === PAGE_UP) {
				e.preventDefault();
				e.stopPropagation();
			}
		};
	domElement.addEventListener('keyup', handler);
	domElement.addEventListener('keydown', handler);
};
